export default {"src":"/_next/static/media/logotype-visitsweden.3a279e16.svg","height":24,"width":136,"blurWidth":0,"blurHeight":0};